import { getData, postData } from "../../api";

export const getStates = async (country_id) => {
    try {
        return await getData(`/states?country_id=${country_id}`);
    } catch (error) {
        console.log(error);
    }
};

export const getCities = async (state_id) => {
    try {
        return await getData(`/districts?state_id=${state_id}`);
    } catch (error) {
        console.log(error);
    }
};

export const getCourses = async (univercity_id) => {
    try {
        return await getData(`/univercityWiseCourses?univercity_id=${univercity_id}`);
    } catch (error) {
        console.log(error);
    }
};

export const getCourseWiseSpecializations = async (course_id) => {
    try {
        return await getData(`/courseWiseSpecializations?course_id=${course_id}`);
    } catch (error) {
        console.log(error);
    }
};

export const postEnquiryForm = async (data) => {
  try {
    return await postData(`/landingPage`, data);
  } catch (error) {
    console.log(error);
  }
};